import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { Image, type StaticImageData } from 'Components/Image';

import { handleKeyPress } from 'utils/a11y';

const ImageContainer = styled.div<{ selected: boolean }>`
  cursor: pointer;

  width: 62px;
  height: 62px;
  margin: 0 12px;
  padding: 4px;
  border: ${({ selected }) =>
    selected ? `1.5px solid ${theme.colors.primary[400]}` : '1px solid transparent'};
  border-radius: 100%;
`;

const VariantWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Variant = {
  slug: string;
  order: number;
  image: { alt: string; src: StaticImageData };
};

type ProductVariantSelectorProps = {
  variants: Variant[];
  onClickVariant: (index: number) => void;
  selectedVariant: Variant['slug'];
};

const ProductVariantSelector = ({
  variants,
  onClickVariant,
  selectedVariant,
}: ProductVariantSelectorProps) => (
  <VariantWrapper>
    {variants.map((variant) => (
      <ImageContainer
        key={variant.slug}
        data-click={variant.slug}
        data-from="pdp-item-selector"
        data-testid={`variant-selector-${variant.slug}`}
        onClick={() => onClickVariant(variant.order - 1)}
        onKeyPress={handleKeyPress(() => onClickVariant(variant.order - 1))}
        selected={selectedVariant === variant.slug}
        tabIndex={0}
      >
        <Image alt={variant.image.alt} height={52} src={variant.image.src} width={52} />
      </ImageContainer>
    ))}
  </VariantWrapper>
);

export default ProductVariantSelector;
